import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";

import { actionBtnTypes, CrudComponent } from "../../../components/boda-boda/CRUD/CrudComponent";
import FilterUI from "./driver_includes/FilterUI";
import { RemoveMessage, RemoveBtn } from "./driver_includes/DeleteUI";
import { getUserDriverList } from "../../../config/boda-boda/apiUrls.config";


class Driver extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { history } = this.props;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h4 className="font-size-18">Driver</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Driver</li>
                </ol>
              </div>
            </Col>
          </Row>

          <Row>
            <CrudComponent
              title="Driver"
              filterFromComponent={FilterUI}
              apiURL={`${getUserDriverList.url}?page=1&limit=20`}
              dataTableStateKey={getUserDriverList.key}
              isDropdownActionBtn={true}
              defaultFilterFormObject={{ id: "", name: "", phone: "", status: "", identification: "", type: "" }}
              createActionProps={{
                actionType: actionBtnTypes.create,
                isSetModel: false,
                onClickBtnFn: () => history.push("/users/driver/create")
              }}
              tableHeaderList={[
                { displayName: "Driver Id", key: "id" },
                { displayName: "Name", key: "name" },
                { displayName: "Type", key: "category" },
                { displayName: "Identification", key: "identification", default: "-" },
                // { displayName: "Phone Number", key: "phone", default: "-" },
                { displayName: "Status", key: "user.staffs[0].status" },
              ]}
              actionList={[
                {
                  actionType: actionBtnTypes.view,
                  isSetModel: false,
                  actionBtn: {
                    onClickBtnFn: (rawData) => history.push(`/users/driver/view/${rawData.id}`),
                  }
                },
                {
                  actionType: actionBtnTypes.other,
                  isSetModel: false,
                  actionBtn: {
                    onClickBtnFn: (rawData) => history.push(`/users/driver/view/${rawData.id}/till-management`),
                    color: "primary",
                    icon: "mdi mdi-account-box-multiple",
                    btnText: "Tills",
                    tooltip: "Till Management",
                  },
                  checkBeforeActionRenderFn: (rawData) => {
                    return rawData.rowData.category === "LAST";
                  }
                },
                {
                  actionType: actionBtnTypes.edit,
                  isSetModel: false,
                  actionBtn: {
                    onClickBtnFn: (rawData) => history.push(`/users/driver/edit/${rawData.id}`),
                  },
                  checkBeforeActionRenderFn: (rawData) => {
                    if (get(rawData, "rowData.user.isSuper", "") !== true) {
                      return true;
                    } else {
                      return false;
                    }
                  }
                },
                {
                  actionType: actionBtnTypes.delete,
                  isSetModel: true,
                  modalProps: {
                    modalTitle: "Please Confirm",
                    modalType: "",
                    modalBodyComponent: RemoveMessage,
                    modalFooterComponent: RemoveBtn,
                    isSetClose: true,
                    isSetFooterClose: true,
                  },
                  checkBeforeActionRenderFn: (rawData) => {
                    if (get(rawData, "rowData.user.isSuper", "") !== true) {
                      return true;
                    } else {
                      return false;
                    }
                  }
                }
              ]}
            />
          </Row>


        </div>
      </React.Fragment>
    )
  }
}

export default Driver;
